import '@main';
import '@vendor/wowjs/dist/wow.min.js';
u.importCSS('@vendor/wowjs/css/libs/animate.css');

new WOW().init();
